/* eslint-disable multiline-ternary */
/* eslint-disable no-mixed-operators */
// ** Third Party Components
import { Info, Edit, Trash } from 'react-feather'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Spinner } from 'reactstrap'
import toast from 'react-hot-toast'
import { downloadInvoiceJSON, downloadInvoiceJsonMh } from '../store'
import { Icon } from '@iconify/react'
// ** Table Common Column

const documentsType = {
  '01': 'Factura',
  '03': 'Comprobante de Crédito Fiscal',
  '04': 'Nota de Remisión',
  '05': 'Nota de Crédito',
  '06': 'Nota de Débito',
  '07': 'Comprobante de retención',
  '08': 'Comprobante de liquidación',
  '09': 'Doc. Contable de liquidación',
  11: 'Facturas de exportación',
  14: 'Factura de sujeto excluido',
  15: 'Comprobante de donación',
}
const CustomActions = ({ row }) => {
  const handleDownloadPDF = (pdf, fileName) => {
    // descargar el archivo pdf que viene en el payload, como PDF %PDF-1.5, pero no es base64
    const url = window.URL.createObjectURL(
      new Blob([pdf], { type: 'application/pdf' })
    )
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${fileName}.pdf`)
    document.body.appendChild(link)
    link.click()

    window.URL.revokeObjectURL(url)
  }

  const handleDownloadJSON = (json, fileName) => {
    const url = window.URL.createObjectURL(
      new Blob([json], { type: 'application/json' })
    )
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${fileName}.json`)
    document.body.appendChild(link)
    link.click()

    window.URL.revokeObjectURL(url)
  }

  const [pending, setPending] = React.useState(false)
  const [pendingJsonMh, setPendingJsonMh] = useState(false)
  const dispatch = useDispatch()

  const handleDownloadJSONError = () => {
    // console.log(row)
    setPending(true)
    dispatch(downloadInvoiceJSON(row))
      .then((response) => {
        // console.log(response)
        if (response.error) return
        if (response.payload.error) return
        handleDownloadJSON(response.payload, row.generationCode)
      })
      .catch((err) => {
        // console.log(err)
        setPending(false)
      })
      .finally(() => setPending(false))
  }

  const handleDownloadJsonMh = () => {
    setPendingJsonMh(true)
    dispatch(downloadInvoiceJsonMh(row))
      .then((response) => {
        if (response.error) return
        if (response.payload.error) return
        handleDownloadJSON(response.payload, row.generationCode)
      })
      .finally(() => setPendingJsonMh(false))
  }

  return (
    <div className="d-flex align-items-center justify-content-center gap-1">
      {row.isSuccessful === 0 && row.generationCode ? (
        <>
          {!pending && (
            <Button
              size="sm"
              outline
              className="cursor-pointer"
              onClick={handleDownloadJSONError}
            >
              <Icon
                icon="bi:filetype-json"
                width={18}
              />{' '}
              Error
            </Button>
          )}
          {pending && (
            <Spinner
              size={18}
              color="info"
            />
          )}

          {!pendingJsonMh && row.generationCode && (
            <Button
              size="sm"
              outline
              className="cursor-pointer"
              onClick={handleDownloadJsonMh}
            >
              <Icon
                icon="bi:filetype-json"
                width={18}
              />{' '}
              MH
            </Button>
          )}
          {pendingJsonMh && (
            <Spinner
              size={18}
              color="info"
            />
          )}
        </>
      ) : (
        <Button
          size="sm"
          outline
          className="cursor-pointer"
          onClick={() =>
            toast.error('Solicite este documento a Soporte Rubridoc', {
              icon: '🔒',
              style: {
                borderRadius: '10px',
                background: '#333',
                color: '#fff',
              },
            })
          }
        >
          <Info size={18} />
        </Button>
      )}
    </div>
  )
}

export function calcularTotales(
  dataTable,
  isExempt,
  isRetained,
  isPerceived,
  receptor
) {
  const IVA_RATE = 0.13
  let totalGravado = 0
  let subTotal = 0
  let basePrice = 0
  // Art. 163 CT: la percepción se calcula "SOBRE EL PRECIO NETO DE VENTA DE
  // LOS BIENES TRANSFERIDOS". Solo los ítems de bienes (CAT-011 código 1)
  // forman su base; los servicios no la alimentan. Ver la asimetría con el
  // art. 162 más abajo
  let baseBienes = 0
  // La retención de renta del FSE (Factura de Sujeto Excluido) solo aplica
  // cuando se compran servicios, no bienes (reportado por Unillantas: una
  // compra de bienes no debe llevar retención del 10%/20%)
  let baseServicios = 0

  dataTable.forEach((item) => {
    // Mismo cálculo y MISMO redondeo que `generateDocumentBodyJson` en
    // utils.js: la rebaja unitaria se redondea a 2 decimales ANTES de
    // multiplicar por la cantidad, y la base del ítem es
    // (precio * cantidad) − montoDescu.
    //
    // Tienen que coincidir exactamente: `resumen.totalGravada` sale de aquí y
    // la suma de `cuerpoDocumento[].ventaGravada` sale de utils. Si cada uno
    // redondea a su manera pueden separarse más de la holgura de $0.01 que
    // admite MH y el documento se rechaza. Con porcentajes fraccionarios —los
    // que produce fusionar dos líneas con descuentos distintos— deja de ser un
    // caso teórico: 200 × 5 al 8.3333 % da 916.67 por un camino y 916.65 por
    // el otro.
    const descuentoUnitario = Number(
      ((Number(item.price) * Number(item.discount || 0)) / 100).toFixed(2)
    )
    const montoDescuItem = Number(
      (descuentoUnitario * Number(item.quantity)).toFixed(2)
    )
    const baseItem = Number(
      (
        Number(item.price) * Number(item.quantity) -
        montoDescuItem
      ).toFixed(2)
    )

    // isExempt no significa "exento de IVA": marca los DTE cuyos precios ya
    // viajan con el IVA incluido (FCF, FEXE, FSSE, CLE). Ahí no se suma nada
    if (!isExempt) {
      totalGravado += Number((baseItem * (1 + IVA_RATE)).toFixed(2))
    } else {
      totalGravado += baseItem
    }

    basePrice += baseItem
    if (String(item?.TypeOfSale?.value) === '1') {
      baseBienes += baseItem
    } else if (String(item?.TypeOfSale?.value) === '2') {
      baseServicios += baseItem
    }
  })
  const IVA = isExempt ? 0 : basePrice * IVA_RATE

  // Código Tributario, arts. 162 (retención) y 163 (percepción): ambos aplican
  // "EL UNO POR CIENTO" en operaciones cuyo precio de venta sea "IGUAL O
  // SUPERIOR A CIEN DÓLARES", y ambos precisan que "PARA EL CÁLCULO... NO
  // DEBERÁ INCLUIRSE EL VALOR QUE CORRESPONDA AL IMPUESTO".
  // De ahí las dos condiciones: umbral con >= y evaluado sobre basePrice (la
  // base sin IVA), no sobre totalGravado — una venta de $95 de base llega a
  // $107.35 con IVA y activaría la retención indebidamente
  const MONTO_MINIMO = 100
  const unoPorCiento = (base) => Number((base * 0.01).toFixed(2))

  // Art. 162 (retención) y art. 163 (percepción) NO tienen el mismo alcance, y
  // por eso no comparten base:
  //   162: "ADQUIERAN BIENES MUEBLES CORPORALES O SEAN PRESTATARIOS O
  //        BENEFICIARIOS DE SERVICIOS ... SOBRE EL PRECIO DE VENTA DE LOS
  //        BIENES TRANSFERIDOS O DE LA REMUNERACIÓN DE LOS SERVICIOS
  //        PRESTADOS"                          -> bienes Y servicios
  //   163: "QUE TRANSFIERAN BIENES MUEBLES CORPORALES ... SOBRE EL PRECIO
  //        NETO DE VENTA DE LOS BIENES TRANSFERIDOS"
  //                                            -> SOLO bienes
  // El umbral de $100 se evalúa sobre la base de cada uno, sin IVA: ambos
  // artículos dicen que "PARA EL CÁLCULO ... NO DEBERÁ INCLUIRSE EL VALOR QUE
  // CORRESPONDA AL IMPUESTO". Una venta de $95 de base llega a $107.35 con IVA
  // y activaría la retención indebidamente si se midiera sobre el total
  const IVA_Retenido =
    !isExempt && isRetained && basePrice >= MONTO_MINIMO
      ? unoPorCiento(basePrice)
      : 0
  const IVA_Percibido =
    !isExempt && isPerceived && baseBienes >= MONTO_MINIMO
      ? unoPorCiento(baseBienes)
      : 0
  // El 20% (extranjero) solo aplica si se eligió explícitamente un país
  // distinto de El Salvador. El formulario de invalidación (#147) no pide
  // país — si se dejara "!= SV" por defecto, toda invalidación de FSE
  // duplicaría la retención (10% -> 20%) por falta de ese dato
  const incomePercent =
    receptor?.country?.value && receptor.country.value !== 'SV' ? 0.2 : 0.1

  subTotal = basePrice
  const RetencionRenta = baseServicios * incomePercent
  // Para CCF/NCE/NDE este valor alimenta resumen.ivaRete: es la retención de
  // IVA del 1% del art. 162, no retención de renta. Mismo umbral
  const RetencionRentaCF = IVA_Retenido
  const total = totalGravado

  return {
    totalGravado: Number(totalGravado.toFixed(2)),
    impuestoValorAgregado: IVA.toFixed(2),
    IVARetenido: IVA_Retenido,
    IVAPercibido: IVA_Percibido,
    retencionRenta:
      receptor?.dteType?.value === '14' || receptor?.emisionType === '14'
        ? RetencionRenta
        : RetencionRentaCF,
    subTotal: Number(subTotal.toFixed(2)),
    total: Number(total.toFixed(2)),
  }
}

export function calcularSubTotal(price, discount, quantity, accept) {
  const IVA_RATE = 0.13
  let totalGravado = 0

  if (accept || true) {
    const totalDiscount = (price * discount) / 100
    const totalTax = (price - totalDiscount) * IVA_RATE
    const total = (price - totalDiscount + totalTax) * quantity
    totalGravado = total
  } else {
    const totalDiscount = (price * discount) / 100

    const total = (price - totalDiscount) * quantity
    totalGravado += total
  }

  return totalGravado
}
export const columns = (
  toggleModalEdit,
  toggleModalDelete,
  calculateSubTotal,
  dteType
) => [
  {
    name: 'Tipo de producto',
    width: '10%',
    center: true,
    selector: (row) => row.prodType.value,
    sortable: true,
    cell: (row) => (
      <div className="d-flex align-items-center text-center">
        {row.prodType.label}
      </div>
    ),
  },
  {
    name: 'Código',
    width: '10%',
    center: true,
    selector: (row) => row.productCode,
    sortable: true,
    cell: (row) => (
      <div className="d-flex align-items-center text-center">
        {row.productCode}
      </div>
    ),
  },
  {
    name: 'Nombre de producto',
    width: '10%',
    center: true,
    selector: (row) => row.productName,
    sortable: true,
    cell: (row) => (
      <div
        className=""
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
        title={row.productName}
      >
        {row.productName}
      </div>
    ),
  },
  {
    name: 'Cantidad',
    width: '10%',
    center: true,
    selector: (row) => row.quantity,
    sortable: true,
    cell: (row) => (
      <div className="d-flex align-items-center text-center">
        {row.quantity}
      </div>
    ),
  },
  {
    name: 'Unidad de medida',
    width: '10%',
    center: true,
    selector: (row) => row.unitOfMeasure.label,
    sortable: true,
    cell: (row) => (
      <div className="d-flex align-items-center text-center">
        {row.unitOfMeasure.label}
      </div>
    ),
  },
  {
    name: 'Tipo de venta',
    width: '10%',
    center: true,
    selector: (row) => row?.TypeOfSale?.value,
    sortable: true,
    cell: (row) => (
      <div className="d-flex align-items-center text-center">
        {row.TypeOfSale?.label}
      </div>
    ),
  },
  {
    name: 'Precio',
    width: '10%',
    center: true,
    selector: (row) => row.price - row.discount + row.price * 0.13,
    sortable: true,
    cell: (row) => (
      <div className="d-flex align-items-center text-center">
        ${' '}
        {calculateSubTotal(
          row.price,
          row.discount,
          1,
          row.accept
        ).toLocaleString('en-US')}
      </div>
    ),
  },
  /*{
    name: 'Aplica impuesto',
    width: '10%',
    center: true,
    selector: row => row.accept,
    sortable: true,
    cell: row => (
      <div className='d-flex align-items-center text-center'>
        {row.accept ? 'Sí' : 'No'}
      </div>
    )
  },*/
  {
    name: 'Subtotal',
    width: '10%',
    center: true,
    selector: (row) => row.accept,
    sortable: true,
    cell: (row) => (
      <div className="d-flex align-items-center text-center">
        ${' '}
        {calculateSubTotal(
          row.price,
          row.discount,
          row.quantity,
          row.accept
        ).toLocaleString('en-US')}
      </div>
    ),
  },
  {
    name: 'Descuento',
    width: '10%',
    center: true,
    selector: (row) => row.discount,
    sortable: true,
    cell: (row) => (
      <div className="d-flex align-items-center text-center">
        {row.discount}%
      </div>
    ),
  },

  {
    name: 'Acciones',
    width: '10%',
    center: true,
    allowOverflow: true,
    cell: (row) => {
      // Ocultar botones si dteType es "note"
      if (dteType) return null

      return (
        <div className="d-flex">
          <div className="cursor-pointer text-primary">
            <Edit
              onClick={() => toggleModalEdit(true, row)}
              size={20}
            />
          </div>
          <div className="ps-1 cursor-pointer text-danger">
            <Trash
              onClick={() => toggleModalDelete(true, row)}
              size={20}
            />
          </div>
        </div>
      )
    },
  },
]
